export default __webpack_public_path__ + "static/media/servicos_mobile.18b4d233.png";